import { DeleteOutlineOutlined, ModeEditOutline } from "@mui/icons-material"
import { Box, IconButton, Typography } from "@mui/material"
import { styled } from "@mui/system"
import AddIcon from '@mui/icons-material/Add';
import { Link, useNavigate } from "@tanstack/react-router";


const StyledCard = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '20px',
    border: '1px solid var(--Light-Gray)',
    borderRadius: '12px',
    boxShadow: '0px 1px 2px 0px #0205111A'
})

const CustomButtonStyle = styled(IconButton)({
    border: '1px solid var(--Interviewer-Near-White)',
    borderRadius: '8px',
    width: '40px',
    height: '40px'
})

interface AdminCategoryCardProps {
    id?: string;
    name?: string;
    description?: string;
    onEdit?: (id: string) => void;
    onDelete?: (id: string) => void;
    onAdd?: (id: string) => void 
}

const InterviewCategoryCard = ({ id, name, description, onEdit, onDelete, onAdd }: AdminCategoryCardProps) => {

    const navigate = useNavigate();

    return (
        <StyledCard>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <Typography variant="h3" sx={{fontSize: '16px'}}>{name}</Typography>
                <Typography sx={{fontSize: '14px', color: 'var(--Interviewer-Lighter-Black)'}}>{description}</Typography>
            </Box>
            <Box sx={{display: 'flex', gap: '16px'}}>
                <CustomButtonStyle onClick={() => 
                    navigate({
                        to: '/create-category',
                        search: {categoryId: id}
                    })
                }>
                    <ModeEditOutline fontSize="small" color="primary" sx={{width: '18px', height: '18px'}} />
                </CustomButtonStyle>
                <CustomButtonStyle onClick={() => onDelete?.(id)}>
                    <DeleteOutlineOutlined fontSize="small" color="primary" sx={{width: '18px', height: '18px'}} />
                </CustomButtonStyle>
                <IconButton
                    color="primary"
                    onClick={() => onAdd?.(id)}
                    // disabled={isLinked}
                    sx={{
                        backgroundColor: 'black',
                        color: 'white',
                        borderRadius: '8px',
                        p: '8px',
                        width: '40px',
                        height: '40px',
                        '&:hover': {
                        backgroundColor: 'var(--Light-Gray)',
                        },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                <AddIcon />
                </IconButton>
            </Box>
        </StyledCard>
    )

}
export default InterviewCategoryCard